$(document).ready(function(){
	$('.showFilters').on('click', function(){
		$('.filters').slideToggle();
	});
	$('.hideFilters').on('click', function(){
		$('.filters').slideUp();
	});
	$('.filters input[type=checkbox]').on('click', function(){
		$(this).parents('.tags').toggleClass('inactive');
	});
	$('.filterForm').on('submit', function(e){
		e.preventDefault();
		var formData = $(this).serializeArray();
		var duration = [], subject = [], old = [], time = [], objective = [];
		$.each(formData, function(key, data){
			if (data.name == 'duration') {
				duration.push(data.value);
			} else if (data.name == 'subject') {
				subject.push(data.value);
			} else if (data.name == 'old') {
				old.push(data.value);
			} else if (data.name == 'time') {
				time.push(data.value);
			} else if (data.name == 'objective') {
				objective.push(data.value);
			}
		});
		var queryParams = '?duration=' + duration.join() + '&subject=' + subject.join() + '&old=' + old.join() + '&time=' + time.join() + '&objective=' + objective.join();
		console.log(window.location.origin + window.location.pathname + queryParams);
		console.log(queryParams);
		window.location.href = window.location.origin + window.location.pathname + queryParams;
	});
});